module.exports = __webpack_public_path__ + "static/projects_hero-916122f6e9e9a1f0e4559bfd486ce291.svg";